<template>
  <sweet-modal ref="update-password" width="60vw" hide-close-button>
    <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
      <h5 class="ba-color-blue1">{{ $t('ct-members-update-password') }}</h5>
      <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="close">
        <builderall-icon code='64f7' />
      </button>
    </div>
    <hr class='ba-hr-row'>
    <div class="ba-grid ba-mg-y-1 ba-gp-08">
      <div class="ba-grid">
        <label for="website-user-email" class="ba-custom-label">{{ $t('ct-email') }}</label>
        <input type="email" class="ba-input ba-md" id="website-user-email" :value="user.email" disabled readonly
          autocomplete="off">
      </div>
      <div class="ba-w-100 ba-flex ba-gp-08">
        <div class="ba-box-input ba-w-50">
          <label for="website-user-password" class="ba-custom-label">{{ $t('ct-password') }}</label>
          <input type="password" id="website-user-password" class="ba-input ba-md" v-model="user.password"
            :class="{ 'ba-error': errors.has('password') }" :placeholder="$t('ct-password')"
            @keydown="errors.clear('password')" required autocomplete="off" />
          <span v-if="errors.has('password')" class="ba-validation-text" v-text="errors.get('password')"></span>
        </div>
        <div class="ba-box-input ba-w-50">
          <label for="website-user-password-confirmation" class="ba-custom-label">{{ $t('ct-password-confirm')
            }}</label>
          <input type="password" id="website-user-password-confirmation" name="website_user_password_confirmation"
            class="ba-input ba-md" v-model="user.password_confirmation"
            :class="{ 'ba-error': errors.has('password_confirmation') }" :placeholder="$t('ct-password-confirm')"
            @keydown="errors.clear('password_confirmation')" required autocomplete="off" />
          <span v-if="errors.has('password_confirmation')" class="ba-validation-text"
            v-text="errors.get('password_confirmation')"></span>
        </div>
      </div>
    </div>
    <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
      <button slot="button" class="ba-btn ba-md ba-light" @click.prevent="close">{{
        $t('ct-cancel') }}</button>
      <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="save">{{ $t('ct-save')
        }}</button>
    </div>
  </sweet-modal>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import Errors from '../../../../js/base/Errors';
import { editPassword } from "../../../../js/services/restrictArea/websiteUsers";

export default {
  name: 'UpdatePassword.vue',

  components: {
    SweetModal
  },

  props: ['website_id'],

  data() {
    return {
      errors: new Errors(),
      user: {
        email: null,
        password: null,
        password_confirmation: null
      }
    };
  },

  methods: {
    open() {
      this.$refs['update-password'].open();
    },

    close() {
      this.clear();
      this.$refs['update-password'].close();
      this.$emit('editWebsiteUser', this.user);
    },

    setUser(user) {
      this.user = { ...this.user, ...user };
    },

    clear() {
      this.user = {
        email: null,
        password: null,
        password_confirmation: null
      };
    },

    save() {
      if (
        this.user.password &&
        this.user.password_confirmation
      ) {
        this.errors.clear();
        this.$loading.show();

        editPassword({ ...this.user })
          .then(({ data }) => {
            if (data.success) {
              this.$snotify.success(this.$t('ct-update-success'));
              this.close();
            } else {
              if (data.validator)
                this.errors.record(data.errors);
            }
          })
          .catch(error => {
            this.$snotify.error(this.$t('ct-success-false'), {
              position: 'centerTop'
            });
          })
          .finally(() => this.$loading.hide());
      }
    }
  }

};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/MembersArea/UpdatePassword.vue